import{jsx as o}from"react/jsx-runtime";import{BackDropLiftContainer as i}from"../../Utils/BackDropLiftContainer/BackDropLiftContainer.js";import{Portal as r}from"../../Utils/Portal/Portal.js";import{DialogBox as t}from"../DialogBox/DialogBox.js";
/**
 * 다이얼로그 컴포넌트
 * @param {Object} props
 * @param {boolean} props.isOpen - 다이얼로그 표시 여부
 * @param {string} [props.rootId] - 포털 루트 ID
 * @param {string} props.title - 다이얼로그 제목
 * @param {string} props.description - 다이얼로그 설명
 * @param {'primary'|'caution'} [props.variant='primary'] - 다이얼로그 스타일
 * @param {() => void} [props.onClose] - 닫기 핸들러
 * @param {() => void} [props.onConfirm] - 확인 핸들러
 * @param {string} [props.confirm] - 확인 버튼 텍스트
 * @param {string} [props.close='닫기'] - 닫기 버튼 텍스트
 * @param {boolean} [props.needCleanup=true] - 포털 정리 필요 여부
 */const n=({isOpen:n,rootId:e,title:s,description:l,variant:a="primary",onClose:m,onConfirm:p,confirm:c,close:d="닫기",needCleanup:f=!0})=>/*#__PURE__*/o(r,{rootId:e,needCleanup:f&&!e,children:/*#__PURE__*/o(i,{isOpen:n,onClose:m,testId:"design-system--dialog",children:/*#__PURE__*/o(t,{title:s,description:l,variant:a,onConfirm:p,onClose:m,confirm:c,close:d})})});export{n as Dialog};
